module.exports = __webpack_public_path__ + "392235b4209742e436824114215763e7.woff2";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Medium.woff2
// module id = 645
// module chunks = 0